<template>
  <div>
    <!-- <p style="font-size:16px;">获取用户ID信息</p> -->
    <p style="font-size:16px;">正在跳转...</p>
  </div>
</template>

<script>

import {getChannelUserId} from '@/api/api'
import wayCodeUtils from '@/utils/wayCode'
import channelUserIdUtil from '@/utils/channelUserId'
import config from "@/config";
export default {
  components: {
  },
  mounted() {

    // 从oauth2回调地址中获取jToken
    const jToken = this.$route.params.jToken;
    if (jToken) {
      // 设置全局token，以便后续接口调用使用
      config.cacheToken = jToken;
    }

    const allQuery = Object.assign({}, this.searchToObject(), this.$route.query)

    const that = this;
    getChannelUserId(allQuery).then(res => {

      //设置channelUserId
      channelUserIdUtil.setChannelUserId(res);

      // this.$router.push({name: wayCodeUtils.getPayWay().routeName})

     // 跳转到支付页面
      const payWay = wayCodeUtils.getPayWay();
      if (payWay && payWay.routeName) {
        this.$router.push({name: payWay.routeName, params: {jToken: config.cacheToken}})
      } else {
        // 如果无法判断支付方式，跳转到Hub重新分发
        this.$router.push({name: 'Hub', params: {jToken: config.cacheToken}})
      }
    }).catch(res => {
      that.$router.push({name: config.errorPageRouteName, params: {errInfo: res.msg}})
    });

  },
  methods: {

    searchToObject: function() {

      if(!window.location.search){
        return {};
      }

      var pairs = window.location.search.substring(1).split("&"),
          result = {},
          pair,
          i;
      for ( i in pairs ) {
        if ( pairs[i] === "" ) continue;
        pair = pairs[i].split("=");
        result[ decodeURIComponent( pair[0] ) ] = decodeURIComponent( pair[1] );
      }
      return result;
    }

  }
}
</script>
